// extracted by mini-css-extract-plugin
export default {"stopwatch_section":"stop-watch-section_stopwatch_section__8wGHF","time":"stop-watch-section_time__eYzbw"};